import { setDocumentTitle } from '@/common/utils/documentTitleBlink'

/** Плейсхолдер вкладки документа, пока имя раздела ещё не посчитано. */
const PENDING_SECTION_TITLE = 'Загрузка...'

let routeDocumentTitle = ''

export function rememberRouteDocumentTitle(title: string | null | undefined): void {
  const next = typeof title === 'string' ? title.trim() : ''
  if (!next) return
  routeDocumentTitle = next
}

/** meta.title маршрута. Не путать с заголовком вкладки браузера. */
export function getRouteDocumentTitle(): string {
  return routeDocumentTitle
}

const SECTION_ROUTE_NAMES = new Set(['platform', 'document'])

export function resolveBrowserDocumentTitle(sectionTitle: string | null | undefined): string {
  const section = typeof sectionTitle === 'string' ? sectionTitle.trim() : ''
  if (!section || section === PENDING_SECTION_TITLE) return ''
  return section
}

export function applyRouteDocumentTitle(title: string | null | undefined): void {
  const next = typeof title === 'string' ? title.trim() : ''
  if (!next) return
  rememberRouteDocumentTitle(next)
  setDocumentTitle(next)
}

/** Для разделов не публикует «Платформа»/«Документ», пока не известно имя формы. */
export function applyNavigationDocumentTitle(
  routeName: unknown,
  title: string | null | undefined,
): void {
  const next = typeof title === 'string' ? title.trim() : ''
  if (!next) return
  if (SECTION_ROUTE_NAMES.has(String(routeName ?? ''))) {
    rememberRouteDocumentTitle(next)
    return
  }
  applyRouteDocumentTitle(next)
}

export function syncBrowserDocumentTitle(
  sectionTitle: string | null | undefined,
  fallbackTitle: string | null | undefined,
): void {
  rememberRouteDocumentTitle(fallbackTitle)
  const title = resolveBrowserDocumentTitle(sectionTitle)
  if (!title) return
  setDocumentTitle(title)
}
